import { Colors } from '../../../../models/disciplines';
import { Tag } from '../../../atoms/Tag';
import { Typography } from '../../../molecules/Typography';

export const TagsFiltersLesson = ({
  discipline,
  selectedFilter,
  onChangeFilter,
  hideComments = false,
}: {
  discipline: Colors;
  selectedFilter: string;
  onChangeFilter: (filter: string) => void;
  hideComments?: boolean;
}) => {
  const tags = [
    {
      label: 'Comentários',
      value: 'comments',
    },
    {
      label: 'Flashcards',
      value: 'flashcards',
    },
    {
      label: 'Materias',
      value: 'materials',
    },
    // {/* @audit Podcasts removido */}
    // {
    //   label: 'Podcasts',
    //   value: 'podcasts',
    // },
    {
      label: 'Exercícios',
      value: 'exercises',
    },
  ].filter((tag) => !(hideComments && tag.value === 'comments'));

  return (
    <div className='hidden flex-wrap gap-sm md:flex '>
      {tags.map((tag) => (
        <Tag
          variant={'transparent'}
          key={tag.value}
          className={`cursor-pointer 
            !rounded-pill 
            border-thin
            px-4
            ${
              selectedFilter === tag.value
                ? `bg-disciplina-${discipline} !border-none`
                : `border-disciplina-${discipline}`
            }`}
          onClick={() => onChangeFilter(tag.value ?? '')}
        >
          <Typography
            className={
              selectedFilter === tag.value ? 'text-mono-color-white' : ''
            }
          >
            {tag.label}
          </Typography>
        </Tag>
      ))}
    </div>
  );
};
